enum SocialAccountProvider {
  facebook = 'facebook',
  google = 'google',
  clever = 'clever',
}

export default SocialAccountProvider;
